module.exports = __webpack_public_path__ + "static/media/typh-bnb.25ae640b.svg";